<section>
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Dicas</ion-title>
    </ion-toolbar>
  </ion-header>
  <hr>
</section>

<ion-content>
  <article>
    <p>{{dica.tituloDica}}<br /><br />
      {{dica.orientacao}}
    </p>
    <h4 *ngIf="dica.efeito">
      Efeitos à saúde
    </h4>
    <p>
      {{dica.efeito}}
    </p>
    <p class="bold">
      {{dica.grupo}}
    </p>
  </article>
</ion-content>